namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPurInvoiceDtEditor extends Serenity.Extensions.GridEditorBase<PoPurInvoiceDtRow> {
        protected getColumnsKey() { return "Purchase.PoPurInvoiceDt"; }
        protected getDialogType() { return PoPurInvoiceDtDialog; }
        protected getLocalTextPrefix() { return PoPurInvoiceDtRow.localTextPrefix; }

        public qnNo: number;

        public myPassValue: string;
        public supid: string;
        public totalamt: number;
        public shopid: string;


        public whsid: string;
        public sumaloamt: number;

        public salevattype: string;
        private _disamt: number;
        private _whsdt: string;
        private _sup: string;
        private _totals: number;
        private _vat: string;
        private _CallPR: string;
        private _salevattype: string;
        private _exvat: number;


        constructor(container: JQuery) {
            super(container);

        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            // let self = this;
            // self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // buttons.push(
            //     {
            //         title: Q.text("สร้างรายการ"),	// *** Get button text from translation
            //         cssClass: '.panel-titlebar-close',
            //         icon: 'fa-add',
            //         onClick: () => {

            //             if (Q.isEmptyOrNull(this.supid)) {
            //                 Q.warning("Choose Supplier Frist!!")
            //             } else {
            //                 // console.log(this.supid)
            //                 // console.log(this.supid +"sup" + this.whsid)
            //                 this.createEntityDialog(this.getItemType(), dlg => {


            //                     var dialog = dlg as PoPurInvoiceDtDialog;
            //                     dialog.onSave = (opt, callback) => this.save(opt, callback);
            //                     var entity = this.getNewEntity() as PoPurInvoiceDtRow;

            //                     entity.SysDocNo = this.myPassValue
            //                     entity.SupplierId = this.supid
            //                     entity.WhsId = this.whsid
            //                     entity.SalesVatTypes = this.salevattype
            //                     entity.ShopId = this.shopid



            //                     dialog.loadEntityAndOpenDialog(entity, false);
            //                 }

            //                 );
            //             }
            //         },
            //     }
            // );
            buttons.push(
                {
                    title: Q.text("Refresh"),	// *** Get button text from translation
                    cssClass: 'button-refresh',
                    icon: 'fa-refresh',
                    onClick: () => {

                        this.refresh();
                    },
                }
            );



            return buttons;
        }
        public DisableAddButton() {
            this.toolbar.findButton('add-button').toggleClass('disabled', true);
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
        }





        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            //--set new set of grid columns---
            //--get content width
            // let ele = document.getElementsByClassName("grid-container");
            // var bordermg = 60;
            // var eleWidth = ele.item(0).clientWidth - bordermg * 5;
            // var totalcolw = 0;

            // let propItems = this.getPropertyItems();
            // let items = this.getColumns();
            // items.forEach((item, idx) => {
            //     let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
            //     totalcolw += pItem.width;

            // });
            // items.forEach((item, idx) => {
            //     let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
            //     pItem.resizable = true;
            //     pItem.width = (eleWidth / totalcolw) * pItem.width;


            // });

            // let c = this.postProcessColumns(this.propertyItemsToSlickColumns(propItems));
            // grid.setColumns(c);
            // grid.resizeCanvas();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Qty'),
                    new Slick.Aggregators.Sum('BeforeDiscAmt'),
                    new Slick.Aggregators.Sum('DiscAmt'),
                    new Slick.Aggregators.Sum('AlocalteDiscAmt'),
                    new Slick.Aggregators.Sum('ItemAmt'),
                    new Slick.Aggregators.Sum('ItemVatAmt'),
                    new Slick.Aggregators.Sum('ItemExVatAmt')
                ]
            });
            return grid;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            // opt.frozenColumn = 1;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

        public get DisAlocate(): number { return this._disamt; }
        public get WhsId(): string { return this._whsdt; }

        public get sup(): string { return this._sup; }
        public get TotalAmt_(): number { return this._totals; }
        public get Vatchange(): string { return this._vat; }
        public get salevatetype(): string { return this._salevattype; }
        public get exvat(): number { return this._exvat; }

        public get CallPR(): string { return this._CallPR; }


        set sup(value: string) {
            if (this._sup != value) {
                console.log("whsid: " + value);
                //  var row =  this.view.getRows();
                this.clearDataGrid();
                this.refresh();
            }
        }

        set TotalAmt_(value: number) {
            this.totalamt = value
            var row = this.view.getRows();
            var i = 0;

            for (var po of row) {
                i++;
                var id = po[this.getIdProperty()]
                var item = this.view?.getItemById?.(id)
                if (item) {
                    item.LineItemNo = i;
                    this.view.updateItem(id, item)
                }
            }
        }

        set salevatetype(value: string) {
            if (this._salevattype != value) {
                this.salevattype = value
                var row = this.view.getRows();
                // this.clearDataGrid();
                var i = 0;
                var sum = 0;

                for (var po of row) {
                    i++;
                    var vatrate = 0.00;
                    var vatcode = '';
                    var vat = 0
                    var exvat = 0
                    var ItemNetCostValue = 0;

                    if (po.VatType != "N") {
                        vatcode = value
                        vatrate = Administration.CsVatCodeRow.getLookup().itemById[value].VatRate
                        if (this.salevattype == "I") {
                            vat = (po.ItemNetAmt * po.VatRate) / (100 + po.VatRate);
                            exvat = po.ItemNetAmt - vat;
                            ItemNetCostValue = po.ItemNetAmt
                        } else {
                            vat = po.ItemNetAmt * (po.VatRate / 100);
                            exvat = po.ItemNetAmt;
                            ItemNetCostValue = po.ItemNetAmt + vat;
                        }
                    } else {
                        vatcode = po.VatCode
                        vatrate = po.VatRate
                        vat = po.ItemVatAmt
                        exvat = po.ItemExVatAmt
                        ItemNetCostValue = po.ItemNetCostValue

                    }

                    var id = po[this.getIdProperty()]
                    var item = this.view?.getItemById?.(id)
                    if (item) {
                        item.LineItemNo = i;
                        item.VatCode = vatcode;
                        item.VatRate = vatrate;
                        item.ItemVatAmt = vat;
                        item.ItemExVatAmt = exvat;
                        item.ItemNetCostValue = ItemNetCostValue;
                        this.view.updateItem(id, item)

                    }

                   

                    this.sumaloamt = sum
                   
                }
            }
        }

        set DisAlocate(value: number) {
            if (this._disamt != value) {
                console.log("disamt: " + value);
                var row = this.view.getRows();
                // this.clearDataGrid();
                var i = 0;
                console.log(this.totalamt + ":total")
                var sum = 0;

                for (var po of row) {
                    i++;
                    let alo = 0;
                    let ItemNetCostValue = 0;
                    let amt = (po.BeforeDiscAmt - po.DiscAmt)
                    let Alocate = (amt * value) / (this.totalamt || 1);
                    sum = sum + Alocate

                    if (sum > value) {
                        alo = Alocate - (sum - value)
                    } else { alo = Alocate }

                    let netamt = po.ItemAmt - alo;
                    // let vat = amt*(po.VatRate/100);//vat Ex
                    var vat = 0.00;
                    var exvat = 0.00;
                    if (this.salevattype == "I") {
                        vat = (netamt * po.VatRate) / (100 + po.VatRate);
                        exvat = netamt - vat;
                        ItemNetCostValue = netamt;
                    } else {
                        vat = netamt * (po.VatRate / 100);
                        exvat = netamt;
                        ItemNetCostValue = netamt + vat;
                    }

                    var id = po[this.getIdProperty()]
                    var item = this.view?.getItemById?.(id)
                    if (item) {
                        item.LineItemNo = i;
                        item.ItemAmt = amt;
                        item.AlocalteDiscAmt = alo;//////                        
                        item.ItemNetAmt = netamt;
                        item.ItemVatAmt = vat;
                        item.ItemExVatAmt = exvat;
                        item.ItemNetCostValue = ItemNetCostValue;
                        this.view.updateItem(id, item)

                    }



                    this.sumaloamt = sum

                }

            }
        }

        set Vatchange(value: string) {
            if (this._vat != value) {
                // console.log("disamt: " + value);
                var row = this.view.getRows();
                // this.clearDataGrid();
                var i = 0;
                var sum = 0;

                for (var po of row) {
                    i++;
                    var vatrate = 0.00;
                    var vatcode = '';
                    var vat = 0;
                    var exvat = 0;
                    var ItemNetCostValue = 0;
                    var netamt = po.ItemNetAmt

                    if (po.VatType != "N") {
                        vatcode = value
                        vatrate = Administration.CsVatCodeRow.getLookup().itemById[value].VatRate
                        console.log(this.salevattype+"rate"+vatrate)
                        if (this.salevattype == "I") {
                            vat = (netamt * vatrate) / (100 + (vatrate||1));
                            exvat = netamt - vat;
                            ItemNetCostValue = netamt
                        } else {
                            vat = netamt * (vatrate / 100);
                            exvat = netamt;
                            ItemNetCostValue = netamt + vat;
                        }
                    } else {
                        vatcode = po.VatCode
                        vatrate = po.VatRate
                        vat = po.ItemVatAmt
                        exvat = po.ItemExVatAmt
                        ItemNetCostValue = po.ItemNetCostValue

                    }

                    console.log(vatcode+"/" +vatrate+"/" +vat+"/" +exvat)

                    var id = po[this.getIdProperty()]
                    var item = this.view?.getItemById?.(id)
                    if (item) {
                        item.LineItemNo = i;  
                        item.VatCode= vatcode;
                        item.VatRate= vatrate;
                        item.ItemVatAmt= vat;
                        item.ItemExVatAmt= exvat;
                        item.ItemNetCostValue = ItemNetCostValue;
                        this.view.updateItem(id, item)

                    }                   
                }              
            }
        }

        

        set exvat(value: number) {
            if (this._exvat != value) {
                // console.log("disamt: " + value);
                var row = this.view.getRows();
                // this.clearDataGrid();
                var i = 0;
                var sum = 0;

                for (var po of row) {
                    i++;
                    
                    let alo = 0;
                    let ItemNetCostValue = 0;
                    let amt = (po.ItemAmt)
                    let Alocate = (amt * value) / (this.totalamt || 1);
                    sum = sum + Alocate

                    if (sum > value) {
                        alo = Alocate - (sum - value)
                    } else { 
                        alo = Alocate }   
                        
                        if (po.VatType != "N") {
                            console.log(this.salevattype+"dtcallpr")
                            if (this.salevattype == "I" ) {
                                
                                ItemNetCostValue = po.ItemAmt+alo
                            } else {                               
                                ItemNetCostValue = po.ItemAmt + po.ItemVatAmt+alo;
                            }
                        } else {
                            ItemNetCostValue = po.ItemAmt    +alo
                        }

                    var id = po[this.getIdProperty()]
                    var item = this.view?.getItemById?.(id)
                    if (item) {
                        item.LineItemNo = i;
                        item.ItemExciseTaxAmt = alo;
                        item.ItemNetCostValue = ItemNetCostValue;                        
                        this.view.updateItem(id, item)

                    }



                    this.sumaloamt = sum

                }
            }
        }

        set WhsId(value: string) {
            if (this._whsdt != value) {
                console.log("whsid: " + value);
                var row = this.view.getRows();
                // this.clearDataGrid();
                var i = 0;
                // console.log(this.totalamt)
                for (var po of row) {
                    i++;
                    var id = po[this.getIdProperty()]
                    var item = this.view?.getItemById?.(id)
                    if (item) {
                        item.LineItemNo = i;
                        item.WhsId = value;
                        this.view.updateItem(id, item)
                    }


                }

            }
        }

       
        set CallPR(value: string) {
            if (this._CallPR != value) {

                var row = PoPurOrderDtRow.getLookup().items
                    .filter(x => x.SysDocNo == value)
                    .sort((a, b) => (Q.toId(a.LineItemNo) || 0) - (Q.toId(b.LineItemNo) || 0));
                this.clearDataGrid();
                var i = 0;
                for (var po of row) {
                    if(po.UseFg !=1){
                    i++;
                    var qtyn = 0;
                    var unit = 0;
                    var purunit = '';
                    var price = 0;
                    var discamt = 0;
                    let lessqty = po.StkQty - po.QtyUse

                        
                    if (po.PurUnitRatio > 1) {
                        let check = lessqty % po.PurUnitRatio
                        if (check > 0) {
                            qtyn = lessqty
                            unit = 0
                            purunit = Product.CsSkuRow.getLookup().itemById[po.SkuCode].StkUnit;
                            price = po.PurUnitPrice / po.PurUnitRatio

                        } else {
                            qtyn = lessqty / po.PurUnitRatio
                            unit = po.UnitChange
                            purunit = po.PurUnit
                            price = po.PurUnitPrice

                        }
                    } else {
                        qtyn = lessqty
                        unit = po.UnitChange
                        purunit = po.PurUnit
                        price = po.PurUnitPrice
                    }

                    let bfdisc = price * qtyn
                    if (!Q.isEmptyOrNull(po.DiscText)) {
                        discamt = this.distext(po.DiscText, bfdisc)
                    }
                    let ItemAmt = bfdisc-discamt

                    var vat = 0
                    var exvat = 0
                    var ItemNetCostValue = 0;

                    if (po.VatType != "N") {
                        console.log(this.salevattype+"dtcallpr")
                        if (this.salevattype == "I" ) {
                            vat = (ItemAmt * po.VatRate) / (100 + po.VatRate);
                            exvat = ItemAmt - vat;
                            ItemNetCostValue = ItemAmt
                        } else {
                            vat = ItemAmt * (po.VatRate / 100);
                            exvat = ItemAmt;
                            ItemNetCostValue = ItemAmt + vat;
                        }
                    } else {
                        
                        vat = 0
                        exvat = ItemAmt

                    }


                    var item = <PoPurInvoiceDtRow>{
                        LineItemNo: i,
                        PrLineId: po.Id,
                        SupplierId: po.SupplierId,
                        WhsId: po.WhsId,
                        PrRefDocNo: po.SysDocNo,
                        ShopId: po.ShopId,
                        SkuCode: po.SkuCode,
                        SkuDesc: po.SkuDesc,
                        Qty: qtyn,
                        UnitChange: unit,
                        PurUnit: purunit,
                        PurUnitPrice: price,
                        LastPurUnitPrice: po.LastPurUnitPrice,
                        PurUnitRatio: po.PurUnitRatio,
                        Remark: po.Remark,

                        BeforeDiscAmt: bfdisc,
                        DiscText: po.DiscText,
                        DiscAmt: discamt,
                        ItemAmt: ItemAmt,
                        // AlocalteDiscAmt: po.AlocalteDiscAmt,
                        // ItemNetAmt: po.ItemNetAmt,

                        SalesVatTypes: po.SalesVatTypes,
                        VatType: po.VatType,
                        VatCode: po.VatCode,
                        VatRate: po.VatRate,

                        ItemVatAmt: vat,
                        ItemExVatAmt: exvat,
                        ItemExciseTaxAmt: 0,
                        ItemNetCostValue: ItemNetCostValue,

                        ExpDate: po.ExpDate,
                        StkQty: lessqty,


                    };

                    var id = this.getNextId();
                    //console.log("get id: " + this.getIdProperty());
                    item[this.getIdProperty()] = id;
                    this.view.addItem(item);
                }
                }

                this.refresh();
            }
        }

        public clearDataGrid() {
            this.view.setItems([], true);
        }

        public distext(dis: string, bfamt: number) {
            var discStr = dis
            if (discStr) {
                //20%,5%,200
                let a = discStr.split(",")
                console.log(a)
                var totalAmt = bfamt;
                var discamt = 0
                //var net = 0

                for (var po of a) {

                    if (po.includes("%")) {
                        let a = po.replace("%", "");
                        let b = Number(a);
                        console.log(b)
                        let amt = totalAmt * b / 100
                        discamt = discamt + amt;
                        totalAmt = totalAmt - amt;
                    } else {
                        let x = Number(po)
                        discamt = discamt + x
                        totalAmt = totalAmt - x;
                    }

                }



                return discamt


            }
        }


    }
}

